<template>
  <div>
    <div class="page">
      <div class="container">
        <div class="content">
          <div class="tips">单一奖项排名不分先后</div>
          <div class="intro">
            品牌经济时代来临，需要寻找品牌价值成长的动力与榜样。2022年起，每日经济新闻设立“中国上市公司经典品牌案例及首席品牌官”系列奖项，旨在揭示优秀品牌的成长之道，彰显中国上市公司品牌价值成长的榜样力量。通过层层筛选，“2024中国上市公司经典品牌案例及首席品牌官”获奖名单正式揭晓，在2024第八届中国上市公司品牌价值榜发布会上隆重发布。
          </div>
          <div class="list">
            <div class="item" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
              <span>{{ item.text }}</span>
              <span class="arrow"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-image">
      <img src="../../assets/xtao/index1.png" alt="" />
      <img src="../../assets/xtao/index2.png" alt="" />
      <img src="../../assets/xtao/index3.png" alt="" />
      <img src="../../assets/xtao/index4.png" alt="" />
    </div>
  </div>
</template>

<script>
import data from './data'
import shareInfo from '../../router/wx'
export default {
  name: 'index',
  data() {
    return {
      list: data,
    }
  },
  mounted() {
    shareInfo.init({
      title: '重磅发布｜2024中国上市公司经典品牌案例及首席品牌官',
      desc: '寻找品牌价值成长的动力与榜样｜每日经济新闻',
      img: 'https://www.nbd.com.cn/zhuanti2023/20221222pinpai/dist/share.jpg',
      shareURL: location.href,
    })
  },
  methods: {
    goDetail(id) {
      if (id == 0) {
        this.$router.push(`/person/${id}`)
      } else {
        this.$router.push(`/winners/${id}`)
      }
    },
  },
}
</script>

<style lang="scss" scoped src="./Index.scss"></style>
